import gql from 'graphql-tag';
import { compose } from 'recompose';
import { get } from 'utils';
import { withMemo } from 'hoc/utils';
import { formatMatchesByType, mapDashFiltersToRules } from 'utils/streams';
import {
    getDefaultStreamOptions,
    getDefaultStreamProps,
    withStreamPaging,
    withUpdateStreamOnChanges
} from 'hoc/streams';
import {
    customDataMatchFragment,
    ruleFragment,
    streamFragment,
    streamMatchTemplateFragment
} from 'graphql/fragments/streams';
import { graphql } from 'graphql/utils';

export const withData = () =>
    compose(
        withMemo({ formatMatches: formatMatchesByType, mapFilters: mapDashFiltersToRules }),
        graphql(
            gql`
                query withCustomStream($streamId: ID, $size: Int = 20, $offset: Int = 0, $filter: StreamMatchFilter) {
                    streams(filter: { streamIds: [$streamId] }) {
                        ...stream
                        rules {
                            ...rule
                        }
                        matches(size: $size, fromIndex: $offset, filter: $filter) {
                            total
                            results {
                                ...customDataMatch
                            }
                        }
                        streamMatchTemplate {
                            ...streamMatchTemplate
                        }
                    }
                }
                ${ruleFragment}
                ${streamFragment}
                ${customDataMatchFragment}
                ${streamMatchTemplateFragment}
            `,
            {
                props: ({ data, ownProps: { formatMatches } }) => {
                    const { fetchMore, loading, matches, refetch, rules, stream, subtitle } = getDefaultStreamProps(
                        data,
                        formatMatches
                    );
                    return {
                        template: get(data, 'streams[0].streamMatchTemplate.configuration'),
                        templateType: get(data, 'streams[0].streamMatchTemplate.templateType'),
                        fetchMore,
                        loading,
                        matches,
                        refetch,
                        rules,
                        stream,
                        subtitle
                    };
                },
                skip: ({ streamId, streamProps }) => !get(streamProps, 'wasVisible', false) || !streamId,
                options: ({ dashDateRange, dashSearchTerm, dashSources, dashEquityScope, mapFilters, streamId }) => {
                    return getDefaultStreamOptions({
                        dashDateRange,
                        dashSearchTerm,
                        dashSources,
                        dashEquityScope,
                        mapFilters,
                        streamId,
                        streamType: 'custom_data'
                    });
                }
            }
        ),
        withUpdateStreamOnChanges(),
        withStreamPaging()
    );
